import request from "../utils/request"

export function fetchAdminAccounts(params) {
  return request({ url: "/admin/system/accounts", method: "get", params })
}

export function createAdminAccount(data) {
  return request({ url: "/admin/system/accounts", method: "post", data })
}

export function updateAdminAccount(id, data) {
  return request({ url: `/admin/system/accounts/${id}`, method: "put", data })
}

export function resetAdminPassword(id, data) {
  return request({ url: `/admin/system/accounts/${id}/reset-password`, method: "post", data })
}

export function fetchAdminRoles() {
  return request({ url: "/admin/system/roles", method: "get" })
}

export function createAdminRole(data) {
  return request({ url: "/admin/system/roles", method: "post", data })
}

export function updateAdminRole(id, data) {
  return request({ url: `/admin/system/roles/${id}`, method: "put", data })
}

export function deleteAdminRole(id) {
  return request({ url: `/admin/system/roles/${id}`, method: "delete" })
}

export function fetchAdminPermissions() {
  return request({ url: "/admin/system/permissions", method: "get" })
}

export function createMerchantAccount(data) {
  return request({ url: "/admin/merchants/accounts", method: "post", data })
}

export function fetchMerchantAccounts() {
  return request({ url: "/admin/merchants/accounts", method: "get" })
}

export function fetchMerchantAccount(id) {
  return request({ url: `/admin/merchants/accounts/${id}`, method: "get" })
}

export function fetchMerchantDetail(id) {
  return request({ url: `/admin/merchants/accounts/${id}/detail`, method: "get" })
}

export function resetMerchantPassword(id, data) {
  return request({ url: `/admin/merchants/accounts/${id}/reset-password`, method: "post", data })
}

export function updateMerchantAccountStatus(id, status) {
  return request({ url: `/admin/merchants/accounts/${id}/status`, method: "put", data: { status } })
}

export function fetchMerchantWeChatPayConfig(id) {
  return request({ url: `/admin/merchants/accounts/${id}/wechat-pay`, method: "get" })
}

export function updateMerchantWeChatPayConfig(id, data) {
  return request({ url: `/admin/merchants/accounts/${id}/wechat-pay`, method: "put", data })
}
